export default __webpack_public_path__ + "static/media/woman-holding-umbrella-in-rain.072f2d18.svg";